// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3rNu0","title":"AfterBackImages_title__7cv8n","images":"AfterBackImages_images__i_HLw"};